import React from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import FormAssembly from "../../../components/FormAssembly/FormAssembly";
import store from "../../../store";
import {Helmet} from "react-helmet";

const billingAndInvoicingForm = () => {
    return (
            <div className="wrapper">
                <Helmet>
                    {
                        store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                            return row.rowTitle === "Manage" ? row.sections.map((section) => {
                                return section.title === "Forms & Applications" ? section.subsections.map((subsection) => {
                                            return subsection.title === "Billing & Invoicing Form" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                        })
                                        : null
                            }) : null
                        }) : null
                    }
                </Helmet>
                <Breadcrumbs/>
                <h1 className="two-three-rows__title">Billing & Invoicing Form</h1>
                <div className="iframe-box-wrapper">
                    <FormAssembly formReferenceName="BILLING_AND_INVOICING_FORM"/>
                </div>
            </div>
    );
};

export default billingAndInvoicingForm;



// WEBPACK FOOTER //
// ./src/pages/manage/FormsAndApplications/BillingAndInvoicingForm.js